/* Layout */
import Layout from '@/layout';
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   如果设置为true，项目将不会显示在侧边栏中(默认为false)
 * alwaysShow: true               如果设置为true，将始终显示根菜单
 *                                如果没有设置alwaysShow，当item有多个子路由时，它将变成嵌套模式，否则不显示根菜单
 * redirect: noRedirect           如果设置了noRedirect，则breadcrumb中不会有重定向
 * name:'router-name'             该名称由<keep-alive>使用(必须设置!!)
 * meta : {
    roles: ['admin','editor']    控制页面角色(可以设置多个角色)
    title: 'title'               在侧边栏和面包屑中显示的名称(推荐设置)
    icon: 'svg-name'/'el-icon-x' 显示在侧边栏中的图标
    breadcrumb: false            如果设置为false，项目将隐藏在breadcrumb中(默认为true)
    activeMenu: '/example/list'  如果设置了path，侧边栏将突出显示您设置的路径
  }
 */

/**
 * constantRoutes
 * 没有权限要求的基页
 * 所有角色均可访问
 */
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true,
  },

  // {
  //   path: '/404',
  //   component: () => import('@/views/404'),
  //   hidden: true
  // },

  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index'),
        meta: { title: '首页', icon: 'dashboard', affix: true },
      },
    ],
  },
  // {
  //   path: '/dataDisplay',
  //   component: Layout,
  //   redirect: '/dataDisplay/onlineMap',
  //   name: 'DataDisplay',
  //   alwaysShow: true,
  //   meta: { title: '数据可视化', icon: 'el-icon-s-marketing' },
  //   children: [
  //     {
  //       path: 'onlineMap',
  //       name: 'OnlineMap',
  //       component: () => import('@/views/dataDisplay/OnlineMap'),
  //       meta: { title: '客户在线地图' },
  //     },
  //     {
  //       path: 'chestCardMap',
  //       name: 'ChestCardMap',
  //       component: () => import('@/views/dataDisplay/ChestCardMap'),
  //       meta: { title: '胸卡地图' },
  //     },
  //     {
  //       path: 'mattress',
  //       name: 'Mattress',
  //       component: () => import('@/views/older/mattress'),
  //       meta: { title: '床垫数据' },
  //     },
  //   ],
  // },
  //  {
  //   path: '/alarm',
  //   component: Layout,
  //   redirect: '/alarm/index',
  //   name: 'Alarm',
  //   meta: { title: '报警信息', icon: 'table' },
  //   children: [
  //     {
  //       path: 'alarmList',
  //       name: 'AlarmList',
  //       component: () => import('@/views/alarm/alarmList'),
  //       meta: { title: '报警列表', icon: 'table' }
  //     },
  // {
  //         path: 'alarmCount',
  //         name: 'AlarmCount',
  //         component: () => import('@/views/alarm/alarmCount'),
  //         meta: { title: '报警统计', icon: 'table' }
  //       },
  //       {
  //         path: 'alarmListManager',
  //         name: 'AlarmListManager',
  //         component: () => import('@/views/alarm/alarmListManager'),
  //         meta: { title: '报警列表（管家）', icon: 'table' }
  //       },
  //       {
  //         path: 'orderListManager',
  //         name: 'OrderListManager',
  //         component: () => import('@/views/alarm/orderListManager'),
  //         meta: { title: '订单列表（管家）', icon: 'table' }
  //       },
  //     {
  //       path: 'orderlist',
  //       name: 'OrderList',
  //       component: () => import('@/views/alarm/orderlist'),
  //       meta: { title: '订单列表', icon: 'table' }
  //     },
  //     {
  //       path: 'routineTicket',
  //       name: 'RoutineTicket',
  //       component: () => import('@/views/alarm/routineTicket'),
  //       meta: { title: '例行创建工单', icon: 'table' }
  //     }
  //   ]
  // },
  // {
  //   path: '/terminalUpgrade',
  //   component: Layout,
  //   redirect: '/terminalUpgrade/upgradeFile',
  //   name: 'TerminalUpgrade',
  //   meta: { title: '终端升级管理', icon: 'table' },
  //   children: [
  //     {
  //       path: 'upgradeFile',
  //       name: 'UpgradeFile',
  //       component: () => import('@/views/terminalUpgrade/upgradeFile'),
  //       meta: { title: '升级文件列表', icon: 'table' }
  //     },
  //     {
  //       path: 'terminalRestart',
  //       name: 'TerminalRestart',
  //       component: () => import('@/views/terminalUpgrade/terminalRestart'),
  //       meta: { title: '终端重启', icon: 'table' }
  //     },
  //     {
  //       path: 'terminalLogin',
  //       name: 'TerminalLogin',
  //       component: () => import('@/views/terminalUpgrade/terminalLogin'),
  //       meta: { title: '登陆终端', icon: 'table' }
  //     }
  //   ]
  // },
  // {
  //   path: '/G1xx-upgrade',
  //   component: Layout,
  //   redirect: '/G1xx-upgrade/productModel',
  //   name: 'G1xx-upgrade',
  //   meta: { title: 'G1XX升级信息', icon: 'table' },
  //   children: [
  //     {
  //       path: 'productModel',
  //       name: 'ProductModel',
  //       component: () => import('@/views/G1xx-upgrade/productModel'),
  //       meta: { title: '产品型号信息', icon: 'table' }
  //     },
  //     {
  //       path: 'mcuData',
  //       name: 'McuData',
  //       component: () => import('@/views/G1xx-upgrade/mcuData'),
  //       meta: { title: 'MCU信息', icon: 'table' }
  //     },
  //     {
  //       path: 'fileUpload',
  //       name: 'FileUpload',
  //       component: () => import('@/views/G1xx-upgrade/fileUpload'),
  //       meta: { title: '文件上传', icon: 'table' }
  //     },
  //     {
  //       path: 'fileUpgrade',
  //       name: 'FileUpgrade',
  //       component: () => import('@/views/G1xx-upgrade/fileUpgrade'),
  //       meta: { title: '文件升级管理', icon: 'table' }
  //     },
  //     // {
  //     //   path: 'deviceUpgrade',
  //     //   name: 'DeviceUpgrade',
  //     //   component: () => import('@/views/G1xx-upgrade/deviceUpgrade'),
  //     //   meta: { title: '设备升级管理', icon: 'table' }
  //     // },

  //   ]
  // },
  // {
  //   path: 'external-link',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'https://www.baidu.com',
  //       meta: { title: '外链', icon: 'link' }
  //     }
  //   ]
  // },

  //  {
  //     path: '/account',
  //     component: Layout,
  //     redirect: '/account/ocAccountManager',
  //     name: 'Account',
  //     meta: { title: '账号管理', icon: 'table' },
  //     children: [
  //       {
  //         path: 'ocAccountManager',
  //         name: 'OcAccountManager',
  //         component: () => import('@/views/account/OcAccountManager'),
  //         meta: { title: '机构账号', icon: 'table' }
  //       },
  //       {
  //         path: 'scAccountManager',
  //         name: 'ScAccountManager',
  //         component: () => import('@/views/account/ScAccountManager'),
  //         meta: { title: '服务中心账号', icon: 'table' }
  //       }
  //     ]
  //   },
  //    {
  //     path: '/backstage',
  //     component: Layout,
  //     redirect: '/backstage/deviceList',
  //     name:'Backstage',
  //     meta: { title: '生产数据', icon: 'el-icon-cpu' },
  //     children: [
  //       {
  //         path: 'deviceList',
  //         name: 'DeviceList',
  //         component: () => import('@/views/backstage/DeviceList'),
  //         meta: { title: '终端/设备库', icon: 'el-icon-cpu' }//, affix: true
  //       },
  //       {
  //         path: 'addBatchDevice',
  //         name: 'AddBatchDevice',
  //         component: () => import('@/views/backstage/AddBatchDevice'),
  //         meta: { title: '新增终端/设备库', icon: 'table' }
  //       },
  //       ,
  //       {
  //         path: 'allotOlderDevice',
  //         name: 'AllotOlderDevice',
  //         component: () => import('@/views/backstage/AllotOlderDevice'),
  //         meta: { title: '分配设备', icon: 'table' }
  //       }
  //     ]
  //   },

  // {
  //   path: '/older',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/older/index'),
  //       name: 'Older',
  //       meta: { title: '客户数据', icon: 'peoples' }//documentation, affix: true
  //     },
  // {
  //   path: 'mattress',
  //   name: 'Mattress',
  //   component: () => import('@/views/older/mattress'),
  //   meta: { title: '床垫数据' },
  // },
  //   ]
  // },
  // {
  //   path: '/manager',
  //   component: Layout,
  //   redirect: '/manager/table',
  //   name: 'Manager',
  //   meta: { title: '管家数据', icon: 'manager' },
  //   children: [
  //     {
  //       path: 'table',
  //       name: 'Table',
  //       component: () => import('@/views/manager/index'),
  //       meta: { title: '管家列表', icon: 'table' }
  //     },
  //     {
  //       path: 'allotManager',
  //       name: 'AllotManager',
  //       component: () => import('@/views/manager/AllotManager.vue'),
  //       meta: { title: '分配管家', icon: 'tree' }
  //     }
  //   ]
  // },
  // {
  //   path: '/setting',
  //   component: Layout,
  //   redirect: '/setting/logo',
  //   name: 'Setting',
  //   meta: { title: '设置', icon: 'el-icon-s-tools' },
  //   children: [
  //     {
  //       path: 'logo',
  //       name: 'Logo',
  //       component: () => import('@/views/setting/index'),
  //       meta: { title: '修改logo' , icon: 'el-icon-s-opportunity'}//
  //     },

  //   ]
  // },
];

export const asyncRoutes = [
  // {
  //   path: '/older',
  //   component: Layout,
  //   redirect: '/older/index',
  //   name: 'Older',
  //   meta: { title: '数据管理', icon: 'peoples' },
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/older/index'),
  //       name: 'Older',
  //       meta: { title: '客户数据', icon: '' }
  //     }
  //   ]
  // },
  // {
  //   path: '/manager',
  //   component: Layout,
  //   redirect: '/manager/table',
  //   name: 'Manager',
  //   meta: { title: '管家数据', icon: 'manager' },
  //   children: [
  //     {
  //       path: 'table',
  //       name: 'Table',
  //       component: () => import('@/views/manager/index'),
  //       meta: { title: '管家列表', icon: 'table' }
  //     },
  //     {
  //       path: 'allotManager',
  //       name: 'AllotManager',
  //       component: () => import('@/views/manager/AllotManager.vue'),
  //       meta: { title: '分配管家', icon: 'tree' }
  //     }
  //   ]
  // },
  // {
  //   path: '/setting',
  //   component: Layout,
  //   redirect: '/setting/backstage',
  //   name: 'Setting',
  //   meta: { title: '平台设置', icon: 'el-icon-cpu' },
  //   children: [
  //     {
  //       path: 'backstage',
  //       name: 'Backstage',
  //       component: () => import('@/views/backstage/index'),
  //       meta: { title: '后台设置', icon: ' ' }
  //     }
  //   ]
  // },
  // { path: '*', redirect: '/404', hidden: true }
];

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
